const LoqateStyles = {
    baseStyle: {
        list: {
            flexWrap: 'wrap',
            borderColor: 'black.100',
            border: '1px solid',
            borderRadius: '3px',
            height: '312px',
            overflow: 'scroll',
            sx: {
                '::-webkit-scrollbar': {
                    width: '3px'
                },

                '::-webkit-scrollbar-thumb': {
                    background: 'var(--chakra-colors-gray-600)',
                    borderRadius: '3px'
                }
            }
        },

        headerBox: {
            backgroundColor: 'white',
            display: 'inline-flex',
            gap: '5px',
            width: '100%',
            cursor: 'pointer',
            padding: '15px'
        },

        headerText: {
            color: 'black',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '22px'
        },

        headerLink: {
            color: 'teal.500',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '22px',
            display: 'flex',
            alignItems: 'center'
        },

        listItem: {
            width: '100%',
            color: 'black',
            padding: '15px',
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '25px',
            letterSpacing: '0.08px',
            cursor: 'pointer',
            display: 'inline-flex',
            justifyContent: 'space-between'
        },

        subResultsWrapper: {
            display: 'inline-flex',
            gap: '0px',
            alignItems: 'center'
        },

        subResultsText: {
            color: 'teal.500',
            fontSize: '12px',
            fontWeight: '400',
            lineHeight: '22px',
            letterSpacing: '0.06px'
        },

        arrowIcon: {
            width: '13px',
            height: '13px'
        }
    }
}

export default LoqateStyles
